import React from "react";
import styled from "styled-components";
import {
    Text, Button, FormField, mobile, tablet, desktop, portalColors,
    PortalFormFieldGroup, PortalFormLabel
} from "src/components";

import CorrectIcon from "src/img/survey/correct.png";
import WrongIcon from "src/img/survey/wrong.png";

import IconRating from "src/img/survey/type_star.png";
import IconSatisfactionBad from "src/img/survey/type_bad.png";
import IconSatisfactionPoor from "src/img/survey/type_poor.png";
import IconSatisfactionOk from "src/img/survey/type_ok.png";
import IconSatisfactionGreat from "src/img/survey/type_great.png";
import IconSatisfactionExcellent from "src/img/survey/type_excellent.png";
import IconYes from "src/img/survey/type_yes.png";
import IconNo from "src/img/survey/type_no.png";
import IconFeedBack from "src/img/survey/type_comment.png";

import IconRatingSelected from "src/img/survey/type_star_Selected.png";
import IconSatisfactionBadSelected from "src/img/survey/type_bad_Selected.png";
import IconSatisfactionPoorSelected from "src/img/survey/type_poor_Selected.png";
import IconSatisfactionOkSelected from "src/img/survey/type_ok_Selected.png";
import IconSatisfactionGreatSelected from "src/img/survey/type_great_Selected.png";
import IconSatisfactionExcellentSelected from "src/img/survey/type_excellent_Selected.png";
import IconYesSelected from "src/img/survey/type_yes_Selected.png";
import IconNoSelected from "src/img/survey/type_no_Selected.png";
import IconFeedBackSelected from "src/img/survey/type_comment_Selected.png";

/*Survey Insights */
import InsightIconRating from "src/img/survey/insight_star.png";
import InsightIconSatisfactionBad from "src/img/survey/insight_bad.png";
import InsightIconSatisfactionPoor from "src/img/survey/insight_poor.png";
import InsightIconSatisfactionOk from "src/img/survey/insight_ok.png";
import InsightIconSatisfactionGreat from "src/img/survey/insight_great.png";
import InsightIconSatisfactionExcellent from "src/img/survey/insight_excellent.png";
import InsightIconYes from "src/img/survey/insight_yes.png";
import InsightIconNo from "src/img/survey/insight_no.png";

import InsightIconRatingSelected from "src/img/survey/insight_star_selected.png";
import InsightIconSatisfactionBadSelected from "src/img/survey/insight_bad_selected.png";
import InsightIconSatisfactionPoorSelected from "src/img/survey/insight_poor_selected.png";
import InsightIconSatisfactionOkSelected from "src/img/survey/insight_ok_selected.png";
import InsightIconSatisfactionGreatSelected from "src/img/survey/insight_great_selected.png";
import InsightIconSatisfactionExcellentSelected from "src/img/survey/insight_excellent_selected.png";
import InsightIconYesSelected from "src/img/survey/insight_yes_selected.png";
import InsightIconNoSelected from "src/img/survey/insight_no_selected.png";

import AddIcon from "src/img/survey/add.png";
import RemoveIcon from "src/img/survey/close.png";
import ArrowCaret from "src/img/arrow-down-sign-to-navigate.svg";
import moment from "moment";
import { FEATURE_FLAGS } from "src/constants/FeatureFlag";

export const NextStepButton = styled(Button).attrs(p => ({
    borderRadius: p.borderRadius || "20px",
    width: p.width || "140px",
    height: p.height || "2.4rem",
    backgroundColor: p.backgroundColor || "#51315D",
    color: p.color || "#ffffff"
}))`
    background: #51315D;
    color: #ffffff;
    border-radius: 20px;
    width: 140px;
    height: 2.4rem;
    margin: 5px 5px;
`;

export const CancelButton = styled(Button).attrs(p => ({
    borderRadius: p.borderRadius || "20px",
    width: p.width || "140px",
    height: p.height || "2.4rem",
    border: p.border || "1px solid #000000",
    backgroundColor: p.backgroundColor || "#ffffff",
    color: p.color || "#000000"
}))`
    background: #ffffff;
    color: #000000;
    border: 1px solid #000000;
    height: ${ p => p.height || "38px"};
    border-radius: ${ p => p.borderRadius || ""} !important;
    width: 140px;
    margin: 5px 5px;
`;

export const SaveButton = styled(Button).attrs(p => ({
    borderRadius: p.borderRadius || "20px",
    width: p.width || "140px",
    height: p.height || "2.4rem",
    border: p.border || "1px solid #000000",
    backgroundColor: p.backgroundColor || "#ffffff",
    color: p.color || "#000000"
}))`
    background: ${ p => p.backgroundColor || "#ffffff"};
    color: ${ p => p.color || "#000000"};
    border: ${ p => p.border || "1px solid #000000"};
    height: ${ p => p.height || "38px"};
    border-radius: ${ p => p.borderRadius || ""} !important;
    width: 140px;
    margin: 5px 5px;
`;

export const GridSurveyTypeContainer = styled.div`
    display: grid;
    grid-template-rows: 100%;
    grid-template-columns: 50% 50%;
    text-align: center;
    padding: 5px 15px;
    cursor: pointer;
    border-radius: 26px;
    border: 2px solid #51315D;
    height: 2.4rem;
    margin-bottom: 14px;
    color: #51315D;

    &.surveyTypeSelected {
        color: #FFF;
        background-color: #51315D;
    }
`;
export const GridSurveyTypeChildStart = styled.div`
    display: flex;
    margin: 0 10px 0 10px;
    align-items: center;
    justify-content: start;

    > img {
        margin: 0 2px;
        height: 36px;
    }
`;
export const GridSurveyTypeChildEnd = styled.div`
    display: flex;
    margin: 0 10px 0 10px;
    align-items: center;
    justify-content: end;

    > img {
        margin: 0 2px;
        height: 36px;
    }
`;

export const GridUserGroupContainer = styled.div`
    display: grid;
    grid-template-rows: 100%;
    text-align: center;
    padding: 5px 15px;
    cursor: pointer;
    border-radius: 26px;
    border: 2px solid #000000;
    height: 2.4rem;
    margin-bottom: 14px;
    box-shadow: 0 4px 2px -2px gray;
    color: #000000;

    &.userGroupSelected {
        color: #FFF;
        background-color: #51315D;
    }
`;
export const GridUserGroupChild = styled.div`
    display: flex;
    margin: 0 10px 0 10px;
    align-items: center;
    justify-content: center;

    > img {
        margin: 0 2px;
        height: 36px;
    }
`;

/*Back and Next Step Container */
export const GridContainer = styled.div`
    display: grid;
    grid-template-rows: 100%;
    grid-template-columns: 50% 50%;
    text-align: center;

    &.SurveyInsightsGridContainer {
        margin: 4px 0 4px 0;
    }
`;

export const GridChild = styled.div`
    margin: ${ p => p.margin || "0 10px 0 10px"};

    > img {
        margin: 0 2px;
        height: 36px;
    }

    > img.icon-surveyInsight {
        height: 46px;
        margin-right: 15px;
    }

    > img.how-it-works {
        margin: 0 2px;
        width: 100%;
        height: auto;
    }
`;

export const StyledButton = styled(Button).attrs(p => ({
    border: p.border || "none",
    borderRadius: p.borderRadius || "7px",
    backgroundColor: p.backgroundColor || "#51315D",
    color: p.color || "white",
    padding: p.padding || "10px 30px 10px"
}))`
    color: ${ p => p.color || "white"};
    background-color: ${ p => p.backgroundColor || "#51315D"};
    border: ${ p => p.border || "none"};
    border-radius: 7px !important;
    padding: 10px 30px 10px;
`;

export const ImageGroupRating = (({ isSelected }) => {
    if (isSelected)
    {
        return (
            <>
                <img className="icon-surveType" src={IconRatingSelected} alt="IconRatingSelected1"/>
                <img className="icon-surveType" src={IconRatingSelected} alt="IconRatingSelected2"/>
                <img className="icon-surveType" src={IconRatingSelected} alt="IconRatingSelected3"/>
                <img className="icon-surveType" src={IconRatingSelected} alt="IconRatingSelected4"/>
                <img className="icon-surveType" src={IconRatingSelected} alt="IconRatingSelected5"/>
            </>
        );
    }
    else
    {
        return (
            <>
                <img className="icon-surveType" src={IconRating} alt="IconRating1"/>
                <img className="icon-surveType" src={IconRating} alt="IconRating2"/>
                <img className="icon-surveType" src={IconRating} alt="IconRating3"/>
                <img className="icon-surveType" src={IconRating} alt="IconRating4"/>
                <img className="icon-surveType" src={IconRating} alt="IconRating5"/>
            </>
        );
    }
});

export const ImageGroupSatisfaction = (({ isSelected }) => {
    if (isSelected)
    {
        return (
            <>
                <img className="icon-surveType" src={IconSatisfactionBadSelected} alt="IconSatisfactionBadSelected"/>
                <img className="icon-surveType" src={IconSatisfactionPoorSelected} alt="IconSatisfactionPoorSelected"/>
                <img className="icon-surveType" src={IconSatisfactionOkSelected} alt="IconSatisfactionOkSelected"/>
                <img className="icon-surveType" src={IconSatisfactionGreatSelected} alt="IconSatisfactionGreatSelected"/>
                <img className="icon-surveType" src={IconSatisfactionExcellentSelected} alt="IconSatisfactionExcellentSelected"/>
            </>
        );
    }
    else
    {
        return (
            <>
                <img className="icon-surveType" src={IconSatisfactionBad} alt="IconSatisfactionBad"/>
                <img className="icon-surveType" src={IconSatisfactionPoor} alt="IconSatisfactionPoor"/>
                <img className="icon-surveType" src={IconSatisfactionOk} alt="IconSatisfactionOk"/>
                <img className="icon-surveType" src={IconSatisfactionGreat} alt="IconSatisfactionGreat"/>
                <img className="icon-surveType" src={IconSatisfactionExcellent} alt="IconSatisfactionExcellent"/>
            </>
        );
    }
});

export const ImageGroupYesNo = (({ isSelected }) => {
    if (isSelected)
    {
        return (
            <>
                <img className="icon-surveType" src={IconYesSelected} alt="IconYesSelected"/>
                <img className="icon-surveType" src={IconNoSelected} alt="IconNoSelected"/>
            </>
        );
    }
    else
    {
        return (
            <>
                <img className="icon-surveType" src={IconYes} alt="IconYes"/>
                <img className="icon-surveType" src={IconNo} alt="IconNo"/>
            </>
        );
    }
});

export const ImageGroupFeedback = (({ isSelected }) => {
    if (isSelected)
    {
        return (
            <>
                <img className="icon-surveType" src={IconFeedBackSelected} alt="IconFeedBackSelected"/>
            </>
        );
    }
    else
    {
        return (
            <>
                <img className="icon-surveType" src={IconFeedBack} alt="IconFeedBack"/>
            </>
        );
    }
});

const CorrectIconContainer = styled.div`
    position: ${ p => p.position };
    left: ${ p => p.left || "60%"};
    top: ${ p => p.top || "-35px"};
    display: ${ p => p.display || "none"};
`;

export const CorrectImage = (({ display }) => {
    return (
        <>
            <CorrectIconContainer display={display}><img className="icon-correct" src={CorrectIcon} alt="CorrectIcon"/></CorrectIconContainer>
        </>
    );
});

export const WrongImage = (({ display }) => {
    return (
        <>
            <CorrectIconContainer display={display}><img className="icon-correct" src={WrongIcon} alt="WrongIcon"/></CorrectIconContainer>
        </>
    );
});

export const CorrectImageSurveyType = (({ display }) => {
    return (
        <>
            <CorrectIconContainer display={display} left="170%" top="-37px"><img className="icon-correct" src={CorrectIcon} alt="CorrectIcon"/></CorrectIconContainer>
        </>
    );
});

/* Question Page */

export const RemoveQuestionIconContainer = (({ display, position, removeQuestion, questionNumber }) => {
    return (
        <>
            <CorrectIconContainer display={display} position={position} left="unset" style={{ right: "-10%", top: "50%" }}><img className="icon-remove" src={RemoveIcon} alt="RemoveIcon" onClick={(event) => {removeQuestion(questionNumber);}} style={{ height: "51px" }}/></CorrectIconContainer>
        </>
    );
});

const CompactQuestionFieldGroup = styled(PortalFormFieldGroup)`
    gap: 0.5rem;

    > label,
    > p {
        margin: 0 0 0.35rem;
    }
`;

export const QuestionContainer = (({ questionNumber, inputQuestion, questionValue, surveyQuestionError, removeQuestion, showRemoveQuestion, isDisabled }) => {
    return (
        <CompactQuestionFieldGroup>
            <PortalFormLabel>
                Question {questionNumber}
            </PortalFormLabel>
            <div style={{ display: "grid", gridTemplateColumns: showRemoveQuestion ? "minmax(0, 1fr) auto" : "minmax(0, 1fr)", gap: "0.75rem", alignItems: "start", width: "100%" }}>
                <div style={{ display: "block", minWidth: 0 }}>
                    <FormField borderRadius="8px" size="0.9375rem" padding="10px 20px" height="46px"
                        placeholderColor={portalColors.textSoft} placeholderAlignment="left" border={`1px solid ${portalColors.borderStrong}`}
                        align="left"
                        width="100%"
                        type="text"
                        margin={questionNumber > 1 ? "0" : ""}
                        placeholder="Enter your question here..."
                        onChange={(event) => {inputQuestion(questionNumber, event);} }
                        errors={surveyQuestionError}
                        value={questionValue}
                        style={{ textAlign: "left", margin: "0" }}
                        showErrors={surveyQuestionError && surveyQuestionError.length > 0}
                        isDisabled={isDisabled}
                    />
                </div>
                { showRemoveQuestion && (
                    <button
                        type="button"
                        onClick={(event) => { removeQuestion(questionNumber); }}
                        style={{
                            width: "2.875rem",
                            height: "2.875rem",
                            border: `1px solid ${portalColors.border}`,
                            borderRadius: "8px",
                            background: portalColors.surfaceSoft,
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 0
                        }}
                        aria-label={`Remove question ${questionNumber}`}
                    >
                        <img className="icon-remove" src={RemoveIcon} alt="" style={{ height: "26px", width: "26px" }}/>
                    </button>
                ) }
            </div>
        </CompactQuestionFieldGroup>
    );
});

export const AddAnotherQuestionContainer = ({ addQuestion, label = "Add Another Question" }) => {
    return (
        <>
            <button
                type="button"
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    border: `1px solid ${portalColors.border}`,
                    borderRadius: "8px",
                    alignItems: "center",
                    background: portalColors.surfaceSoft,
                    height: "46px",
                    cursor: "pointer",
                    margin: "0.75rem 0 0",
                    color: portalColors.text,
                    fontFamily: "Manrope, Helvetica, sans-serif",
                    fontSize: "0.9375rem",
                    fontWeight: 700,
                    padding: "0 1rem"
                }}
                onClick={addQuestion}
            >
                <div style={{ marginRight: "0.5rem", display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <img className="add-question" src={AddIcon} alt="" height="24px"/>
                </div>
                {label}
            </button>
        </>
    );
};

export const InputSelector = styled.select`
    border-radius: 26px;
    border: 1px solid #2D3037;
    height: 2.4rem;
    text-align: center;
    background: url(${ArrowCaret}) no-repeat right #FFF;
    background-position: calc(100% - 1rem) calc(100% - 0.75rem) !important;
    -moz-appearance: none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    font-size: ${p => p.size || "0.8rem"};
    color: ${ p => p.color || "#000"};
    font-weight: ${ p => p.fontWeight || "bolder" };
    border: ${ p => p.border || "1px solid #2D3037" };
    border-bottom: ${ p => p.borderBottom };
    margin: ${ p => p.margin || "5px 0" };
    box-sizing: border-box;
    
    overflow: ${p => p.hiddenOverFlow && "hidden"};
    ::placeholder {
        opacity: ${ p => p.opacity || "initial" };
        color: ${ p => p.placeholderColor || "#6A1E00" };
        font-weight: 400;
    };
    
`;

/* Page Insight */

export const ImageGroupRatingInsight = (({ isSelected, score1 = 0, score2 = 0, score3 = 0, score4 = 0, score5 = 0 }) => {
    return (
        <>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "score5" && score5 > 0 ? InsightIconRatingSelected : InsightIconRating} alt="InsightIconRating5"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{score5}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">5 Stars</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "score4" && score4 > 0 ? InsightIconRatingSelected : InsightIconRating} alt="InsightIconRating4"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{score4}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">4 Stars</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "score3" && score3 > 0 ? InsightIconRatingSelected : InsightIconRating} alt="InsightIconRating3"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{score3}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">3 Stars</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "score2" && score2 > 0 ? InsightIconRatingSelected : InsightIconRating} alt="InsightIconRating2"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{score2}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">2 Stars</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "score1" && score1 > 0 ? InsightIconRatingSelected : InsightIconRating} alt="InsightIconRating1"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{score1}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">1 Stars</Text>
                </GridChild>
            </GridContainer>
        </>
    );
});

export const ImageGroupSatisfactionInsight = (({ isSelected, bad = 0, poor = 0, ok = 0, great = 0, excellent = 0 }) => {
    return (
        <>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "excellent" && excellent > 0 ? InsightIconSatisfactionExcellentSelected : InsightIconSatisfactionExcellent} alt="InsightIconSatisfactionExcellent"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{excellent}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Excellent</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "great" && great > 0 ? InsightIconSatisfactionGreatSelected : InsightIconSatisfactionGreat} alt="InsightIconSatisfactionGreat"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{great}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Great</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "ok" && ok > 0 ? InsightIconSatisfactionOkSelected : InsightIconSatisfactionOk} alt="InsightIconSatisfactionOk"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{ok}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Ok</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "poor" && poor > 0 ? InsightIconSatisfactionPoorSelected : InsightIconSatisfactionPoor} alt="InsightIconSatisfactionPoor"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{poor}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Poor</Text>
                </GridChild>
            </GridContainer>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "bad" && bad > 0 ? InsightIconSatisfactionBadSelected : InsightIconSatisfactionBad} alt="InsightIconSatisfactionBad"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{bad}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Bad</Text>
                </GridChild>
            </GridContainer>
        </>
    );
});

export const ImageGroupYesNoInsight = (({ isSelected, yes = 0, no = 0 }) => {
    return (
        <>
            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "yes" && yes > 0 ? InsightIconYesSelected : InsightIconYes} alt="InsightIconYes"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{yes}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Answered &rdquo;Yes&rdquo;</Text>
                </GridChild>
            </GridContainer>

            <GridContainer className="SurveyInsightsGridContainer" align="center" style={{ display: "flex" }} >
                <GridChild margin="0">
                    <img className="icon-surveyInsight" src={isSelected === "no" && no > 0 ? InsightIconNoSelected : InsightIconNo} alt="InsightIconNo"/>
                </GridChild>
                <GridChild margin="0">
                    <Text color="#000" size="20px" weight="500" align="left" margin="0">{no}</Text>
                    <Text color="#000" size="13px" weight="500" align="left" margin="0">Answered &rdquo;No&rdquo;</Text>
                </GridChild>
            </GridContainer>
        
        </>
    );
});


export const FormBackground = styled.div`
    position: relative;
    width: 100%;
    max-width: 1512px;
    background: ${portalColors.surface};
    height: auto;
    min-height: 5.625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 16px;
    border: 1px solid ${portalColors.border};
    box-shadow: ${portalColors.shadow};
    box-sizing: border-box;
    margin-bottom: 2.5rem;
    overflow: hidden;
    
    ${tablet`
        padding: 1rem 0;
        flex-direction: column;
    `};

    ${mobile`
        padding: 1rem 0;
        flex-direction: column;
    `};

    ${desktop`
        padding: 0;
        flex-direction: row;
    `};
`;

export const FormSectionHeader = styled.div`
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 1rem;
    color: ${portalColors.text};
    font-weight: 800;
    line-height: 1.3;
    letter-spacing: 0;
    margin-bottom: 0.85rem;
`;

export const DropdownSelector = styled.select`
    width: 100%;
    border-radius: 12px;
    text-decoration: none;
    color: white;
    height: 50px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    padding: 0.3em 1.1em;
    color: #000000;
    font-size: 1rem;
    font-family: Manrope, Helvetica, sans-serif;
    background-image: url(${ArrowCaret});
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: 50%;
    appearance: none;
`;

export const LoadingIndicatorButton = styled.div`
    background: #ffffff;
    color: #000000;
    border: 1px solid #000000;
    height: ${ p => p.height || "38px"};
    width: ${ p => p.width || "150px"};
    display: flex;
    border-radius: ${ p => p.borderRadius || "12px"};
`;

export const StyledCheckbox = styled.div`
background-clip: content-box;
background-color: ${props => (props.checked ? props.color || "#85b336" : "white")};
border: 1px solid #2D3037;
box-sizing: border-box;
height: ${p => p.height || "20px"};
padding: ${p => p.padding || "5px"};
border-radius: ${ p => p.radius || "0"};
transition: all 150ms;
width: ${p => p.width || "20px"};
`;

export const countSurveyResponseValue = (responsesStats, responseType, surveyQuestionUuid) => {
    let surveyQuestionResponses = responsesStats.filter((item) => 
    { 
        if (item.surveyQuestionUuid === surveyQuestionUuid) {
            return item;
        }
    });

    return surveyQuestionResponses.filter((item) => item.answerChosen === responseType).length;
};

export const evaluateAverageCategory = (categoriesCountArray) => {
    /**
     * Forumla taken from: https://www.omnicalculator.com/statistics/five-star-rating
     * FORMULA USED: average rating = (5r5 + 4r4 + 3r3 + 2r2 + r1) / (r5 + r4 + r3 + r2 + r1)
     * r5 = Excellent / 5 stars / categoriesCountArray[4]
     * r4 = Great / 4 stars / categoriesCountArray[3]
     * r3 = Ok / 3 stars / categoriesCountArray[2]
     * r2 = Poor / 2 stars / categoriesCountArray[1]
     * r1 = Bad / 1 star / categoriesCountArray[0]
     * categoriesCountArray is arranged by 
     * satisfaction => [badCount, poorCount, okCount, greatCount, excellentCount]
     * rating => [oneStarCount, twoStarsCount, threeStarsCount, fourStarsCount, fiveStarsCount]
     * 
     */
    const r5 = (5 * categoriesCountArray[4]);
    const r4 = (4 * categoriesCountArray[3]);
    const r3 = (3 * categoriesCountArray[2]);
    const r2 = (2 * categoriesCountArray[1]);
    const total = categoriesCountArray[4] + categoriesCountArray[3] + categoriesCountArray[2] + categoriesCountArray[1] + categoriesCountArray[0];
    if (total === 0) {
        return 0;
    }

    return ((r5 + r4 + r3 + r2 + categoriesCountArray[0]) / total);
};

export const randomNumber = (min, max) => {
    return Math.random() * (max - min) + min;
};

export const generateYesNoLineGraphData = (responsesStats, setLineGraphData, setStartAtZero) => {
    let responses = responsesStats.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    let labels = [];
    let responseRange = [];

    if (responses.length === 1) {
        setStartAtZero(true);
        labels.push("blank");
        responseRange.push(0);
    }
    responses.forEach((responseItem) => {
        labels.push(moment(responseItem.createdAt).format("M/DD/YYYY HH:mm:ss"));
        let valueToPush = 0;

        switch (responseItem.answerChosen) {
            case "yes":
                valueToPush = Math.round(randomNumber(0.5, 1));
                break;
            case "no":
                valueToPush = Math.round(randomNumber(-0.5, -1));
                break;
        }
        responseRange.push(valueToPush);
    });

    setLineGraphData({
        labels,
        datasets: [
            {
                label: "Dataset 1",
                data: responseRange,
                fill: false,
                cubicInterpolationMode: "monotone",
                tension: 0.4,
                borderColor: "#02BC77",
                pointRadius: 0,
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                yAxisID: "y",
            }
        ],
    });
};

export const generateYesNoBarGraphData = (responsesStats, setLineGraphData, surveyQuestionUuid) => {
    const labels = [""];
    const yesCountedResult = countSurveyResponseValue(responsesStats, "yes", surveyQuestionUuid);
    const noCountedResult = countSurveyResponseValue(responsesStats, "no", surveyQuestionUuid);

    setLineGraphData({
        labels,
        datasets: [
            {
                label: "Yes",
                data: [yesCountedResult],
                fill: true,
                backgroundColor: "#02BC77",
                barThickness: 100,
                borderWidth: 1,
                categoryPercentage: 0.5,
                barPercentage: 0.5
            },
            {
                label: "No",
                data: [noCountedResult],
                fill: true,
                backgroundColor: "#0274BC",
                barThickness: 100,
                borderWidth: 1,
                categoryPercentage: 0.5,
                barPercentage: 0.5
            }
        ],
    });
};


/* Polls Form */

export const AnswerContainer = ({ 
    answerNumber,
    inputAnswerChange,
    answerValue,
    disabled,
    isEditForm,
    errors,
    showErrors,
    showRemoveQuestion,
    removeAnswer,
    answerIndex }) => {
    return (
        <PortalFormFieldGroup>
            <PortalFormLabel>
                Option {answerNumber}
            </PortalFormLabel>
            <div style={{ display: "grid", gridTemplateColumns: showRemoveQuestion ? "minmax(0, 1fr) auto" : "minmax(0, 1fr)", gap: "0.75rem", alignItems: "start", width: "100%" }}>
                <div style={{ display: "block", minWidth: 0 }}>
                    <FormField
                        borderRadius="8px"
                        size="0.9375rem"
                        padding="10px 20px"
                        height="46px"
                        placeholderColor={portalColors.textSoft}
                        placeholderAlignment="left"
                        border={`1px solid ${portalColors.borderStrong}`}
                        align="left"
                        width="100%"
                        type="text"
                        placeholder="Enter option details..."
                        onChange={(event) => {inputAnswerChange(answerNumber, event, isEditForm);} }
                        value={answerValue}
                        disabled={disabled}
                        errors={errors}
                        showErrors={showErrors}
                        style={{ textAlign: "left", margin: "0" }}
                    />
                </div>
                { showRemoveQuestion && (
                    <button
                        type="button"
                        onClick={() => { removeAnswer(answerIndex); }}
                        style={{
                            width: "2.875rem",
                            height: "2.875rem",
                            border: `1px solid ${portalColors.border}`,
                            borderRadius: "8px",
                            background: portalColors.surfaceSoft,
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 0
                        }}
                        aria-label={`Remove option ${answerNumber}`}
                    >
                        <img className="icon-remove" src={RemoveIcon} alt="" style={{ height: "26px", width: "26px" }}/>
                    </button>
                ) }
            </div>
        </PortalFormFieldGroup>
    );
};

export const AddAnotherAnswerContainer = ({ addAnswer }) => (
    <AddAnotherQuestionContainer addQuestion={addAnswer} label="Add Another Option" />
);


export const RemoveAnswerIconContainer = ({ display, position, removeAnswer, answerIndex }) => {
    return (
        <>
            <CorrectIconContainer display={display} position={position} left="unset" style={{ right: "-10%", top: "50%" }}><img className="icon-remove" src={RemoveIcon} alt="RemoveIcon" onClick={(event) => {removeAnswer(answerIndex - 1);}} style={{ height: "51px" }}/></CorrectIconContainer>
        </>
    );
};

export const getSurveyPollFeatureContext = (featureFlags = []) => {
    const flags = Array.isArray(featureFlags) ? featureFlags : [];
    const hasSurveys = flags.includes(FEATURE_FLAGS.SURVEYS);
    const hasPolls = flags.includes(FEATURE_FLAGS.POLLS);

    return {
        hasSurveys,
        hasPolls,
        title:
            hasSurveys && hasPolls
                ? "Surveys & Polls"
                : hasSurveys
                    ? "Surveys"
                    : hasPolls
                        ? "Polls"
                        : "",

        singularLabel:
            hasSurveys && hasPolls
                ? "survey and poll"
                : hasSurveys
                    ? "survey"
                    : hasPolls
                        ? "poll"
                        : "",

        onlySurveys: hasSurveys && !hasPolls,
        onlyPolls: hasPolls && !hasSurveys,
        both: hasSurveys && hasPolls,
        none: !hasSurveys && !hasPolls,

        options: [
            ...(hasPolls ? [{ value: "polls", label: "Polls" }] : []),
            ...(hasSurveys ? [{ value: "surveys", label: "Surveys" }] : [])
        ]
    };
};
